import React from "react";

function Teaching0204() {
	return (
	<div className="content_inpage">
		<div className="pagesize">
			<ul className="bread">
				<li><a href="/">首頁</a></li>						
				<li><a href="/container/teaching">教學&QA</a></li>
				<li><a href="/container/teaching/Teaching0204">情境教學說明</a></li>
			</ul>		
					
			<h2 className="tit_main">情境教學說明</h2>
			<div className="content_box">
				<div className="steps steps_x3 flex_set">
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step1</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation01.jpg").default} alt="img_step_situation01" /></div>
						<div className="sb_txt">
							<p>在下方選單中，選擇「功能」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step2</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation02.jpg").default} alt="img_step_situation02" /></div>
						<div className="sb_txt">
							<p>選擇「情境模式」。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step3</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation03.jpg").default} alt="img_step_situation03" /></div>
						<div className="sb_txt">
							<p>選擇想設定的情境模式。(以起床為例)</p>
						</div>
					</div>
				</div>
				<div className="steps steps_x3 flex_set">
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step4</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation04.jpg").default} alt="img_step_situation04" /></div>
						<div className="sb_txt">
							<p>1.各情境模式下(圖示以起床為例)，用戶可自由設定「生活助理、智慧家庭、音樂故事」類別中想要啟動的服務與設備。<br/>2.請點選「+」進行設定。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step5</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation05.jpg").default} alt="img_step_situation05" /></div>
						<div className="sb_txt">
							<p>「生活助理」設定頁:方框可選擇多項服務，並可透過久按「三條線ICON」進行拖拉，調整音箱播報順序。</p>
						</div>
					</div>
					<div className="step_box flex_box">
						<div className="sb_num"><span>Step6</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation06.jpg").default} alt="img_step_situation06" /></div>
						<div className="sb_txt">
							<p>「智慧家庭」設定頁:方框可選擇多項設備，勾選後可設定家電的開關狀態。</p>
						</div>
					</div>
				</div>
				<div className="steps steps_x3 flex_set">
					<div className="step_box">
						<div className="sb_num"><span>Step7</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation07.jpg").default} alt="img_step_situation07" /></div>
						<div className="sb_txt">
							<p>「音樂故事」設定頁:此類別中僅能選「一項」串流服務進行播放，部分服務(如音樂、廣播)可以下拉式選單進行類別篩選。</p>
						</div>
					</div>
					<div className="step_box">
						<div className="sb_num"><span>Step8</span></div>
						<div className="sb_img"><img src={require("../../image/img_step_situation08.jpg").default} alt="img_step_situation08" /></div>
						<div className="sb_txt">
							<p>1.設定完成後，就可透過不同情境的「喚醒語」啟動情境模式囉!<br/>2.點擊左上角「&lt;」回到畫面。<br/>3.查看情境選單。</p>
						</div>
					</div>
				</div>
			</div>
		</div>						
	</div>
	)
}

export default Teaching0204;